import {createSlice} from "@reduxjs/toolkit";
import type {PayloadAction} from "@reduxjs/toolkit";
import {AuthStateEnum} from "@/types/enums/AuthStateEnum";

export interface IStep {
    authState: AuthStateEnum
}

const initialState: IStep = {
    authState: AuthStateEnum.INITIAL
};
export const StepSlice = createSlice({
    name: "step_slice",
    initialState,
    reducers: {
        changeAuthState: (state, action: PayloadAction<number>) => {
            sessionStorage.setItem("state", action.payload.toString());
            state.authState = action.payload;
        },
    },
});

export const {
    changeAuthState
} = StepSlice.actions;

export default StepSlice.reducer;